import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavLink } from '../types';

interface NavbarProps {
  navLinks: NavLink[];
}

const Navbar: React.FC<NavbarProps> = ({ navLinks }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (href: string) => {
    closeMenu();
    
    // If we're on a different page and trying to navigate to a section on the home page
    if (location.pathname !== '/' && href.startsWith('#')) {
      // Navigate to home page first, then scroll to section after a brief delay
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return;
    }
    
    // If we're on the home page and clicking a section link
    if (location.pathname === '/' && href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-brand">Sohail Mo</Link>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => {
            // Special handling for blog link
            if (link.href === '#blog') {
              return (
                <li key={link.href}>
                  <Link to="/blog" className="nav-link" onClick={closeMenu}>
                    {link.label}
                  </Link>
                </li>
              );
            }
            
            // For section links on home page
            if (link.href.startsWith('#')) {
              return (
                <li key={link.href}>
                  <Link 
                    to="/" 
                    className="nav-link" 
                    onClick={() => handleNavClick(link.href)}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            }
            
            // For external or other links
            return (
              <li key={link.href}>
                <a href={link.href} className="nav-link" onClick={closeMenu}>
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
